function OfferCancellationsController($scope, $interpolate, $resource, $state, $stateParams, $q, ColumnDefinitionService, NgTableParams, ItemidForLoanNumService) {
    'ngInject'

    const ctrl = this;
    const uri = '/clientportal/api/';

    let parameter = $stateParams.parameter;
    ctrl.parameter = parameter;
    if (moment(parameter, moment.ISO_8601, true).isValid()){
        ctrl.titleparam = moment(parameter, moment.ISO_8601, true).format('MM-DD-YYYY');
    }else{
        ctrl.titleparam = ctrl.parameter;
    }
    if(ctrl.titleparam === '__all__'){
        ctrl.titleparam = 'All';
    }

    ctrl.data = [];
    ctrl.showfullerror = false;
    ctrl.showerror = false;
    ctrl.showsuccess = false;

    let res = $resource(uri + 'RPT_OfferCanacellationDrillThrough/:id/?format=json&nopage=1', {id:'@id'}, {
        'update': { method:'PATCH' }
    });
/*    let res = $resource(uri + 'RPT_OfferCanacellationDrillThrough/?format=json&nopage=1', {id:'@id','AgentId':$stateParams.AgentId}, {
        'update': { method:'PATCH' }
    });*/
    let GetIDByATLoanNumber = $resource(uri + 'GetIDByATLoanNumber/:id?nopage=1&format=json', {id:'@id'});


    ctrl.tableParams = new NgTableParams({
        count: 15
    }, {
        filterDelay: 0
    });

    ctrl.load = function(){
        res.query({id: parameter}).$promise.then(data => {
            Load_Data(data);
        });
    }

    ctrl.load();

    ctrl.save = function save(row) {
        console.log(row);
        ctrl.showerror = false;
        ctrl.showsuccess = false;

        row.id = row.ItemId;

        row.$update(function(data){
            console.log('success, got data: ', data);
            ctrl.showsuccess = true;
            ctrl.load();
        }, function(err){
            ctrl.showerror = true;
            if("data" in err && "detail" in err["data"]){
                ctrl.error = err["data"]["detail"];
            }else{
                ctrl.error = err["statusText"];
            }

            ctrl.fullError = err;
        });

        //Save/patch the data
        //On successful return
        //  reload data
        //On fail
        //  notify user

        // alert("Work In Progress");
    };

    //-------------------------------------
    function Load_Data(data) {
        ItemidForLoanNumService.get(data).then((data) => {
            console.log(data);
            ctrl.data = data;
            ctrl.tableParams.settings({
                dataset: ctrl.data
            });

            ctrl.data_loaded = true;

            ctrl.data['show_otherTextBox']=false;


            angular.forEach(ctrl.data, (data) => {
                angular.forEach(data, (value, key) => {
                    var dt=new Date(value);
                    if ( (value !==null) && dt !== "Invalid Date" && !isNaN(dt) ) {
                        var isZDate = value.toString().indexOf("00Z") >=0;
                        console.log("Date is " + value + " is zdate: " + isZDate);
                        if (isZDate) {
                            var dtn = new Date(value);
                            data[key] = new Date(dtn.getFullYear(), dtn.getMonth(),dtn.getDate());
                        }
                    }
                })
            });
        });
    }

    ctrl.propertyDetailsCB = function(row){
        console.log(row);
        $state.go('PropertyDetails', {'id':row['id']});
    };
}

export default {
    name: 'OfferCancellationsController',
    fn: OfferCancellationsController
};
